"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductFieldDataTaxCategory = void 0;
exports.ProductFieldDataTaxCategory = {
    StandardTaxable: "standard-taxable",
    StandardExempt: "standard-exempt",
    BooksReligious: "books-religious",
    BooksTextbook: "books-textbook",
    Clothing: "clothing",
    ClothingSwimwear: "clothing-swimwear",
    DigitalGoods: "digital-goods",
    DigitalService: "digital-service",
    DrugsNonPrescription: "drugs-non-prescription",
    DrugsPrescription: "drugs-prescription",
    FoodBottledWater: "food-bottled-water",
    FoodCandy: "food-candy",
    FoodGroceries: "food-groceries",
    FoodPrepared: "food-prepared",
    FoodSoda: "food-soda",
    FoodSupplements: "food-supplements",
    MagazineIndividual: "magazine-individual",
    MagazineSubscription: "magazine-subscription",
    ServiceAdmission: "service-admission",
    ServiceAdvertising: "service-advertising",
    ServiceDryCleaning: "service-dry-cleaning",
    ServiceHairdressing: "service-hairdressing",
    ServiceInstallation: "service-installation",
    ServiceMiscellaneous: "service-miscellaneous",
    ServiceParking: "service-parking",
    ServicePrinting: "service-printing",
    ServiceProfessional: "service-professional",
    ServiceRepair: "service-repair",
    ServiceTraining: "service-training",
};
